import {
    Dialog, DialogTitle, DialogContent,
    Button, TextField, DialogActions
} from "@mui/material";
import React, {useEffect, useState} from "react";
interface BoatDisqualificationNoteDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (value: string|null) => void;
    defaultValue?: string;
}

const BoatDisqualificationNoteDialog: React.FC<BoatDisqualificationNoteDialogProps> = ({
                                                                                           open,
                                                                                           onClose,
                                                                                           onSave,
                                                                                           defaultValue
                                                                                       }) => {
    const [value, setValue] = useState<string>(defaultValue ? defaultValue.toString() : "");

    useEffect(() => {
        if (open) {
            setValue(defaultValue ? defaultValue.toString() : "");
        }
    }, [open, defaultValue]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
        >
            <DialogTitle>
                Informace o diskvalifikaci lodi
            </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    label="Důvod diskvalifikace"
                    type="text"
                    fullWidth
                    variant="standard"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    setValue("");
                    onSave(null);
                    onClose();
                }}>
                    Neuvádět
                </Button>
                <Button
                    onClick={() => {
                        onSave(value);
                        setValue("");
                        onClose();
                    }}
                    variant="contained"
                    color="success"
                >
                    Uložit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BoatDisqualificationNoteDialog;
